module.exports = __webpack_public_path__ + "img/logo-sv.3b3ab524.svg";